import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Cropper from 'react-easy-crop';

import Button from '../Button';

import styles from './ImageCropperStyles.scss';
import ImageService from '../../services/ImageService';

export default class ImageCropper extends Component {
  static propTypes = {
    imageSrc: PropTypes.string,
    onCropComplete: PropTypes.func.isRequired,
    style: PropTypes.object,
    remoteImage: PropTypes.string,
  };

  static defaultProps = {
    imageSrc: '',
    remoteImage: undefined,
    style: undefined,
  };

  state = {
    imageSrc: this.props.imageSrc,
    crop: { x: 0, y: 0 },
    zoom: 1,
    aspect: 1 / 1,
    croppedAreaPixels: null,
    croppedImage: null,
  };

  onCropChange = crop => {
    this.setState({ crop });
  };

  onCropComplete = (croppedArea, croppedAreaPixels) => {
    this.setState({ croppedAreaPixels });
  };

  onZoomChange = zoom => {
    this.setState({ zoom });
  };

  createImage = url =>
    new Promise((resolve, reject) => {
      const image = new Image();
      image.addEventListener('load', () => {
        resolve(image);
      });
      image.addEventListener('error', error => reject(error));
      // image.setAttribute('crossOrigin', 'anonymous'); // needed to avoid cross-origin issues on CodeSandbox
      image.src = url;
    });

  getCroppedImg = (imageSrc, pixelCrop) =>
    this.createImage(imageSrc).then(img => {
      const image = img;
      const canvas = document.createElement('canvas');
      canvas.width = pixelCrop.width;
      canvas.height = pixelCrop.height;
      const ctx = canvas.getContext('2d');

      ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        pixelCrop.width,
        pixelCrop.height,
      );

      // As Base64 string
      // return canvas.toDataURL('image/jpeg');

      // As a blob
      return new Promise((resolve, reject) => {
        canvas.toBlob(file => {
          resolve(file);
        }, 'image/png');
      });
    });

  applyCrop = () =>
    this.getCroppedImg(this.state.imageSrc, this.state.croppedAreaPixels).then(
      croppedImg => {
        const croppedImage = croppedImg;
        this.setState(
          { croppedImage: URL.createObjectURL(croppedImage) },
          () => {
            this.props.onCropComplete(croppedImage);
          },
        );
      },
    );

  render() {
    const { croppedImage } = this.state;
    const { style, remoteImage } = this.props;

    const hasImage = !!(croppedImage || remoteImage);

    return (
      <div className={styles.wrapper} style={{ ...style }}>
        {!hasImage && (
          <div className={styles.cropper}>
            <Cropper
              image={this.state.imageSrc}
              crop={this.state.crop}
              zoom={this.state.zoom}
              aspect={this.state.aspect}
              showGrid
              onCropChange={this.onCropChange}
              onCropComplete={this.onCropComplete}
              onZoomChange={this.onZoomChange}
            />
          </div>
        )}
        {!hasImage && (
          <div className={styles.controlWrapper}>
            <Button
              className={styles.applyButton}
              onClick={this.applyCrop}
              text="Apply"
              style={{
                width: '64px',
                height: '34px',
                backgroundColor: '#464646',
                color: '#fff',
                border: 'none',
                fontSize: '1.2rem',
                fontWeight: 'normal',
              }}
            />
            <div className={styles.sliderWrapper}>
              <input
                type="range"
                min="1"
                max="3"
                step="0.1"
                value={this.state.zoom}
                className={styles.slider}
                onChange={(e, zoom) => {
                  this.onZoomChange(e.target.value);
                }}
              />
            </div>
          </div>
        )}

        {hasImage && (
          <img
            src={
              remoteImage ? ImageService().getFull(remoteImage) : croppedImage
            }
            width="200"
            height="200"
            className={styles.preview}
          />
        )}
      </div>
    );
  }
}
